<!-- MODAL Agregar documento recibido manualmente -->
<div mdbModal #agregarDoc="mdb-modal" class="modal fade" style="overflow-y: auto" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 90%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar Documento recibido manualmente</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseDocRecManualmente()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="filtros-body">
          <form autocomplete="off" [formGroup]="formHeader">
            <div class="row">
              <div class="col" style="max-width: 150px">
                <div class="md-form mb-0">
                  <mdb-select label="Mes/Periodo" [options]="optionsMonth" placeholder="Mes/Periodo"
                    [filterEnabled]="true" formControlName="mesPeriodo"> </mdb-select>
                  <div
                    *ngIf="formHeader.get('mesPeriodo').invalid && (formHeader.get('mesPeriodo').dirty || formHeader.get('mesPeriodo').touched)">
                    <mdb-error *ngIf="formHeader.get('mesPeriodo').hasError('required')">Ingrese periodo </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col" style="max-width: 150px">
                <div class="md-form mb-0">
                  <mdb-select label="Gestión" [options]="optionsYear" placeholder="Gestión" [filterEnabled]="true"
                    formControlName="gestion"> </mdb-select>
                  <div
                    *ngIf="formHeader.get('gestion').invalid && (formHeader.get('gestion').dirty || formHeader.get('gestion').touched)">
                    <mdb-error *ngIf="formHeader.get('gestion').hasError('required')">Ingrese gestión </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col" style="max-width: 150px">
                <div class="md-form">
                  <input value="" type="text" class="form-control" placeholder="" required
                    [readonly]="AddlistaDetalleDocRec.length  > 0" formControlName="rutProveedor" formatRut />
                  <label for="rutproveedor">RUT Proveedor</label>
                  <div
                    *ngIf="noExisteProveedor === true || formHeader.get('rutProveedor').invalid && (formHeader.get('rutProveedor').dirty || formHeader.get('rutProveedor').touched)">
                    <mdb-error *ngIf="formHeader.get('rutProveedor').hasError('required')">Ingrese Proveedor
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-dm-1">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                      (click)="openModalSeleccionarProveedor()" [disabled]="AddlistaDetalleDocRec?.length > 0">
                      <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                  </div>
                  <div class="col" style="align-self: center;">
                    <h6 class="text-info" *ngIf="proveedorSeleccionado">
                      {{ proveedorSeleccionado.nombre }}
                    </h6>
                  </div>
                </div>

              </div>
              <div class="col" style="max-width: 200px;" *ngIf="disabledTipoFact">
                <div class="md-form" *ngIf="disabledTipoFact">
                  <mdb-select label="Tipo de factura" formControlName="tipoFact" [options]="optionsTipoFact"
                    placeholder="Seleccionar" [filterEnabled]="true"></mdb-select>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <input value="" (input)="OnChangeFolio($event.target.value)" type="number" class="form-control"
                    placeholder="" required formControlName="nFolio" #Folio />
                  <label for="Folio">Folio</label>
                  <div
                    *ngIf="formHeader.get('nFolio').invalid && (formHeader.get('nFolio').dirty || formHeader.get('nFolio').touched) || NoExisteFolio === true;">
                    <mdb-error *ngIf="formHeader.get('nFolio').hasError('required')">Ingrese Folio </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaInicio" formControlName="FechaDoc"
                    [placeholder]="'Fecha Doc.'" required> </mdb-date-picker>
                  <div
                    *ngIf="formHeader.get('FechaDoc').invalid && (formHeader.get('FechaDoc').dirty || formHeader.get('FechaDoc').touched)">
                    <mdb-error *ngIf="formHeader.get('FechaDoc').hasError('required')">Ingrese fecha de Doc.
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col">
                <Strong class="title">Fecha de vencimiento</Strong>
                <div>
                  <!-- <span class="value" *ngIf="headerData?.fechaVencimiento">{{ headerData.fechaVencimiento | date }}</span> -->
                  <span class="value" *ngIf="headerData?.fechaVencimiento; else dummyTxt">{{ headerData.fechaVencimiento
                    | fecha
                    }}</span>
                  <ng-template #dummyTxt>
                    <div class="dummyTxt"></div>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <mdb-select label="Condición de pago" formControlName="CondPago" [options]="optionsCondPago"
                    placeholder="Seleccionar condición de pago" [filterEnabled]="true"></mdb-select>
                </div>
              </div>
              <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <input value="" type="text" id="glosaNominal" class="form-control" formControlName="GlosaN"
                    placeholder="Glosa General" #direccion />
                  <label for="glosaNominal">Glosa General</label>
                </div>
              </div>

              <div class="col">
                <mdb-checkbox formControlName="EntregaGratuita">Entrega gratuita </mdb-checkbox>
                <mdb-checkbox formControlName="MontoBrutoDetalle">Montos detalle en Bruto </mdb-checkbox>
                <!-- <mdb-checkbox formControlName="MueveInventario">Mueve Inventanrio </mdb-checkbox> -->
              </div>


              <div class="col" style="max-width: 400px"
                [ngStyle]="{'display': formItems.get('esProductoLibre').value == false ? 'block' : 'none'}">
                <mdb-checkbox formControlName="MueveInventario" (change)="changeShowInventario()">Mueve Inventario
                </mdb-checkbox>
              </div>
              <div class="col" style="max-width: 200px">
                <div class="md-form" *ngIf="showBodega">
                  <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true"
                    [highlightFirst]="false" placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
                  <label>Bodega</label>
                </div>
              </div>

              <!-- <div class="row align-items-center">
                <div class="col" style="max-width: 400px"><mdb-checkbox formControlName="IvaUsoComun" (change)="changeShowFactor()">IVA de uso comun</mdb-checkbox></div>
                <div class="col" style="max-width: 200px">
                <div class="md-form" *ngIf="showFactor" >
                  <input value="" formControlName="FactorIva" type="number" id="factor" class="form-control" placeholder="Factor" required #factor />
                  <label for="factor">Factor</label>
                </div>
                </div>
              </div> -->

            </div>

            <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
              <h4>Totales cabecera</h4>
            </div>
          </form>
          <div class="row">
            <!-- Totales -->
            <div class="col">
              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <tbody class="blue lighten-5">
                    <tr>
                      <!-- <td><strong>SubTotal</strong></td> -->
                      <td>
                        <div style="display: flex">
                          <strong>Monto Neto</strong>
                        </div>
                      </td>
                      <td>
                        <div style="display: flex">
                          <strong>Monto Exento</strong>
                        </div>
                      </td>
                      <td><strong>Desc. Global</strong></td>
                      <td><strong>Recar. Global</strong></td>
                    </tr>
                  </tbody>
                  <tbody class="blue lighten-5">
                    <tr>
                      <!-- <td style="width: 200px;" align="right">
                        <input *ngIf="pago.tipo_pago_cuenta_codigo === 1" type="text" id="input11" class="form-control"
                        placeholder="" [(ngModel)]="pago.pago_cuenta_utilizado" (change)="pagoCuentaUtilizadoChange($event)"
                        monto /> -->
                      <!-- <span *ngIf="pago.tipo_pago_cuenta_codigo === 2 && !pago.seleccion">$ 0</span>
                        <span *ngIf="pago.tipo_pago_cuenta_codigo === 2 && pago.seleccion">$ {{pago.saldo | numerico}}</span> -->
                      <!-- <span *ngIf="pago.tipo_pago_cuenta_codigo === 2">$ {{pago.pago_cuenta_utilizado | numerico}}</span>
                        </td> -->
                      <!-- <td>
                        <input disabled value="" [(ngModel)]="SubTotal" type="text" class="form-control"
                          placeholder="..." />
                      </td> -->
                      <td align="right">
                        <input value="" (input)="OnChangeTotalxAfecto($event.target.value)" [(ngModel)]="MontoAf"
                          type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" (input)="OnChangeTotalxExento($event.target.value)" [(ngModel)]="MontoEx"
                          type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="DescGbl" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="RecargoGbl" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <div class="MontoIva">
                          <strong> Monto IVA</strong>
                        </div>
                      </td>
                      <td><strong>IVA Recuperable</strong></td>
                      <td><strong>IVA No-Recuperable</strong></td>
                      <td><strong>IVA Activo Fijo</strong></td>
                      <td><strong>IVA Retenido</strong></td>
                      <td><strong>IVA en Comun</strong></td>
                    </tr>
                  </tbody>
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <input value="" (input)="OnChangeTotalxIva($event.target.value)" [(ngModel)]="MontoIva"
                          type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaRec" type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaNoRec" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaActF" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaRet" type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaComn" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right"><strong>Total Bruto</strong></td>
                    </tr>
                  </tbody>
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <strong>{{ TotalBruto | numerico }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col grey lighten-5">
              <!-- Impuestos adicionales -->
              <div class="row">
                <div class="col">
                  <div style="display: flex">
                    <h5>Impuestos Adicionales</h5>
                  </div>
                </div>
              </div>
              <form autocomplete="off" [formGroup]="formImpuestos">
                <div class="row">
                  <div class="col">
                    <div class="md-form">
                      <mdb-select label="Seleccionar" [options]="optionsSelect" placeholder="Seleccionar"
                        [filterEnabled]="true" formControlName="impAdic"></mdb-select>
                    </div>
                  </div>

                  <div class="col" style="max-width: 200px">
                    <div class="md-form">
                      <input value="{{ impuesto }}" type="text" id="campo1" class="form-control" placeholder="..."
                        disabled required #campo1 />
                      <label for="campo1"></label>
                    </div>
                  </div>

                  <div class="col align-items-center">
                    <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect
                      (click)="OnAddImpuestoAd()">Agregar</button>
                  </div>
                </div>
              </form>

              <div class="row">
                <div class="col">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                      <tbody class="grey lighten-5">
                        <tr>
                          <td align="center">
                            <mdb-checkbox (change)="checkAllChange($event)" [(ngModel)]="checkAll"></mdb-checkbox>
                          </td>
                          <td><strong>Código</strong></td>
                          <td><strong>Detalle</strong></td>
                          <td align="right"><strong>%</strong></td>
                        </tr>
                      </tbody>
                      <tbody *ngFor="let dynamic of dynamicArray; let i = index" class="grey lighten-5">
                        <tr>
                          <td align="center">
                            <mdb-checkbox [checked]="dynamic.checked" (change)="checkDetalle(dynamic, $event)">
                            </mdb-checkbox>
                          </td>
                          <td>{{ dynamic.codigo }}</td>
                          <td>{{ dynamic.detalle }}</td>
                          <td align="right">{{ dynamic.valor | numerico}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row justify-content-between">
                <div class="col align-items-center">
                  <button type="button" mdbBtn color="warning" size="sm" mdbWavesEffect (click)="OnDeleteDetail()">
                    <span *ngIf="countSelectImp === 0">Eliminar</span>
                    <span *ngIf="countSelectImp > 0"> Eliminar {{ countSelectImp }} seleccionados</span>
                  </button>
                </div>

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="{{ montoTotal }}" type="text" id="campo1" class="form-control" placeholder="0" #campo1
                      disabled />
                    <label for="campo1">Total Impuestos adicionales</label>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <form autocomplete="off" [formGroup]="formItems">
            <div class="row filtros-header"
              style="border-bottom: 1px solid #dee2e6; justify-content: space-between; align-items: center">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <h4 class="mb-0">Ingreso de Item</h4>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="row justify-content-end">
                  <div class="col d-flex align-items-center" style="max-width: 165px">
                    <p class="m-0">
                      <small>
                        <mdb-checkbox formControlName="esProductoLibre">Producto sin SKU</mdb-checkbox>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="formItems.get('esProductoLibre').value" formGroupName="productoLibre">
              <div class="row">
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="" type="text" id="codProductLibre" class="form-control" placeholder="000" required
                      #codProductLibre formControlName="codigo" monto />
                    <label for="codProductLibre">Código de producto</label>
                    <div
                      *ngIf="formItems.get('productoLibre.codigo').invalid && (formItems.get('productoLibre.codigo').dirty || formItems.get('productoLibre.codigo').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.codigo').hasError('required')">Ingrese código de
                        producto </mdb-error>
                      <mdb-error *ngIf="formItems.get('productoLibre.codigo').hasError('min')">Código de producto debe
                        ser mayor a 0 </mdb-error>
                    </div>
                  </div>
                </div>

                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input value="" type="text" id="descripcionProductoLibre" class="form-control" placeholder=""
                      required #descripcionProductoLibre formControlName="descripcion" />
                    <label for="descripcionProductoLibre">Descripción</label>
                    <div
                      *ngIf="formItems.get('productoLibre.descripcion').invalid && (formItems.get('productoLibre.descripcion').dirty || formItems.get('productoLibre.descripcion').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.descripcion').hasError('required')"> Ingrese
                        descripción de producto </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select [options]="optionsFormatoProductoLibre" [multiple]="false" [filterEnabled]="false"
                      [highlightFirst]="false" placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
                    <label>Formato</label>
                    <div
                      *ngIf="formItems.get('productoLibre.formato').invalid && (formItems.get('productoLibre.formato').dirty || formItems.get('productoLibre.formato').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.formato').hasError('required')">Ingrese formato
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required
                      #cant formControlName="cantidad" monto />
                    <label for="cant">Cantidad</label>
                    <div
                      *ngIf="formItems.get('productoLibre.cantidad').invalid && (formItems.get('productoLibre.cantidad').dirty || formItems.get('productoLibre.cantidad').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.cantidad').hasError('required')">Ingrese cantidad
                      </mdb-error>
                      <mdb-error *ngIf="formItems.get('productoLibre.cantidad').hasError('min')">Cantidad debe ser mayor
                        a 0 </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <div class="">
                    <input value="" type="text" id="precioUnitario" class="form-control" placeholder="000" required
                      #precioUnitario formControlName="precioUnitario" monto />
                    <label for="precioUnitario">Precio unitario</label>
                    <div
                      *ngIf="formItems.get('productoLibre.precioUnitario').invalid && (formItems.get('productoLibre.precioUnitario').dirty || formItems.get('productoLibre.precioUnitario').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.precioUnitario').hasError('required')"> Ingrese
                        precio unitario </mdb-error>
                      <mdb-error *ngIf="formItems.get('productoLibre.precioUnitario').hasError('min')"> Precio unitario
                        debe ser mayor a 0 </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col d-flex align-items-center">
                  <!-- Material inline 1 -->
                  <div class="form-check form-check-inline" style="margin-right: 20px">
                    <input type="radio" class="form-check-input" mdbInput id="producto_libre_afecto"
                      [value]="PRODUCTO_LIBRE_AFECTO" formControlName="es_exento" />
                    <label class="form-check-label" for="producto_libre_afecto">Afecto</label>
                  </div>

                  <!-- Material inline 2 -->
                  <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" mdbInput id="producto_libre_exento"
                      [value]="PRODUCTO_LIBRE_EXCENTO" formControlName="es_exento" />
                    <label class="form-check-label" for="producto_libre_exento">Exento</label>
                  </div>
                </div>
              </div>
            </ng-container>

            <div formGroupName="productoExistente" *ngIf="!formItems.get('esProductoLibre').value">
              <div class="row">
                <div class="col" style="max-width: 150px">
                  <div class="md-form">
                    <mdb-select ngDefaultControl label="Tipo de Item" id="filtroItems" #Itemsfiltro
                      [options]="optionsTipoItem" placeholder="Seleccionar" [filterEnabled]="true"
                      formControlName="tipoItems"></mdb-select>
                  </div>
                </div>
                <div class="col" style="display: none;">
                  <mdb-checkbox formControlName="ActivoFijo">Item es Activo Fijo</mdb-checkbox>
                </div>
                <div class="col" style="max-width: 150px">
                  <div class="md-form">
                    <input value="" formControlName="codProduct" type="text" id="codProduct" class="form-control"
                      placeholder="000" required #codProduct />
                    <label for="codProduct">Código de producto</label>
                    <div
                      *ngIf="NoExisteFolio === true || formItems.get('productoExistente.codProduct').invalid && (formItems.get('productoExistente.codProduct').dirty || formItems.get('productoExistente.codProduct').touched)">
                      <mdb-error *ngIf="formItems.get('productoExistente.codProduct').hasError('required')"> Ingrese
                        codigo del producto
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 70px">
                  <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                    (click)="OpenSelectProduct()">
                    <mdb-icon fas icon="search"></mdb-icon>
                  </button>
                </div>
                <div class="col mt-3" style="max-width: 200px">
                  <h6 class="text-info" *ngIf="productoSeleccionado">
                    {{ productoSeleccionado.producto_descripcion.trim() }}
                  </h6>
                </div>

                <div class="col" style="max-width: 100px">
                  <div class="md-form">
                    <input value="" disabled formControlName="formatCode" type="text" id="formatCode"
                      class="form-control" placeholder="AA" #formatCode />
                    <label for="formatCode">Formato</label>
                    <!-- <div
                      *ngIf="formItems.get('productoExistente.formatCode').invalid && (formItems.get('productoExistente.formatCode').dirty || formItems.get('productoExistente.formatCode').touched)">
                      <mdb-error *ngIf="formItems.get('productoExistente.formatCode').hasError('required')"> Ingrese
                        unidad de medida
                      </mdb-error>
                    </div> -->
                  </div>
                </div>
                <div class="col" style="max-width: 100px">
                  <div class="md-form">
                    <input value="" formControlName="codCantidad" [(ngModel)]="cantidadRecibida"
                      (input)="onChangeAmount($event.target.value)" type="number" id="codProduct" class="form-control"
                      placeholder="0" required #codProduct monto />
                    <label for="codProduct">Cantidad</label>
                  </div>
                </div>
                <div class="col" style="max-width:150px">
                  <div class="md-form">
                    <input value="" formControlName="codPrecioU" [(ngModel)]="PrecioUni"
                      (input)="onChangePrecioU($event.target.value)" type="text" id="codProduct" class="form-control"
                      placeholder="0" required #codProduct monto />
                    <label for="codProduct">Precio Unitario</label>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col" style="max-width: 300px">
                  <mdb-checkbox formControlName="AsigImpuesto" (change)="changeShowImpuesto()">Asignar impuesto
                    adicional </mdb-checkbox>
                </div>

                <div class="col">
                  <div class="md-form" *ngIf="showImpuesto" style="max-width: 300px">
                    <mdb-select label="Seleccionar" (selected)="onChangeTax($event)" [options]="optionsSelect"
                      placeholder="Seleccionar" [filterEnabled]="true" formControlName="impAdic"
                      [(ngModel)]="ImpuestoCod"></mdb-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="" formControlName="codDescuento" [(ngModel)]="descuentoCod" type="number"
                      (input)="onChangeDiscount($event.target.value)" id="descuento" class="form-control"
                      placeholder="0" required #descuento />
                    <label for="descuento">Descuento</label>
                  </div>
                </div>

                <div class="col" style="max-width: 80px">
                  <!-- Material inline 1 -->
                  <div class="form-check mt-3" style="margin-right: 20px; max-width: 50px">
                    <input type="radio" formControlName="tipoDesc" name="tipoDesc" class="form-check-input"
                      id="descPorcentaje" [value]="RB_TIPO_PORCENTAJE_DESC" mdbInput />
                    <label class="form-check-label" for="descPorcentaje">%</label>
                  </div>
                </div>
                <div class="col" style="max-width: 80px">
                  <!-- Material inline 1 -->
                  <div class="form-check mt-3" style="margin-right: 20px; max-width: 50px">
                    <input type="radio" formControlName="tipoDesc" name="tipoDesc" class="form-check-input"
                      id="descPeso" [value]="RB_TIPO_PESO_DESC" mdbInput />
                    <label class="form-check-label" for="descPeso">$</label>
                  </div>
                </div>

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="" formControlName="codRecargo" [(ngModel)]="RecargoCod"
                      (input)="onChangeSurcharge($event.target.value)" type="number" id="recargo" class="form-control"
                      placeholder="000" required #recargo />
                    <label for="recargo">Recargo</label>
                  </div>
                </div>

                <div class="col" style="max-width: 80px">
                  <!-- Material inline 1 -->
                  <div class="form-check mt-3" style="margin-right: 20px; max-width: 50px">
                    <input type="radio" name="tipoRec" class="form-check-input" id="recPorcentaje"
                      formControlName="tipoRec" [value]="RB_TIPO_PORCENTAJE_REC" mdbInput />
                    <label class="form-check-label" for="recPorcentaje">%</label>
                  </div>
                </div>
                <div class="col" style="max-width: 80px">
                  <!-- Material inline 1 -->
                  <div class="form-check mt-3" style="margin-right: 20px; max-width: 50px">
                    <input type="radio" name="tipoRec" class="form-check-input" id="recPeso" formControlName="tipoRec"
                      [value]="RB_TIPO_PESO_REC" mdbInput />
                    <label class="form-check-label" for="recPeso">$</label>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="{{ totalLine | numerico }}" disabled type="text" id="totalLinea" class="form-control"
                      placeholder="000" required #totalLinea />
                    <label for="totalLinea">Total Linea</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
              <div></div>
              <button type="button" mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="AddDetalle()"
                *ngIf="!formItems.get('esProductoLibre').value">
                Agregar producto
              </button>
              <button type="button" mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="AddDetalleSinSKU()"
                *ngIf="formItems.get('esProductoLibre').value">
                Agregar producto sin SKU
              </button>
            </div>
          </form>
          <div class="p-3">
            <!-- TABLA -->
            <div class="row">
              <div class="col">
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm align-middle">
                    <tbody class="grey lighten-5">
                      <tr>
                        <td align="center">
                          <mdb-checkbox (change)="checkAllChangeDetalle($event)" [(ngModel)]="checkAllDetalle">
                          </mdb-checkbox>
                        </td>
                        <td><strong>Cod. Prod.</strong></td>
                        <td><strong>Descripción</strong></td>
                        <!-- <td><strong>Activo fijo</strong></td> -->
                        <td><strong>Cant.</strong></td>
                        <td><strong>UniMed</strong></td>
                        <td><strong>Precio-U</strong></td>
                        <td><strong>Desc.</strong></td>
                        <td><strong>Rec.</strong></td>
                        <td><strong>CodERP</strong></td>
                        <td><strong>Detalle</strong></td>
                        <td><strong>Tipo</strong></td>
                        <td><strong>Total</strong></td>
                      </tr>
                    </tbody>
                    <tbody class="grey lighten-5">
                      <tr *ngIf="AddlistaDetalleDocRec?.length === 0">
                        <td colspan="100%" style="text-align: center">No se encontró información</td>
                      </tr>
                      <tr *ngFor="let doc of AddlistaDetalleDocRec; let i = index">
                        <td align="center">
                          <mdb-checkbox [checked]="doc.additionalInfo.checked"
                            (change)="checkDetalleList(doc.additionalInfo, $event)"></mdb-checkbox>
                        </td>
                        <td>{{ doc.producto_proveedor }}</td>
                        <td>
                          <span *ngIf="doc.producto_proveedor_descripcion === null"></span>
                          <span *ngIf="doc.producto_proveedor_descripcion != null">{{
                            doc.producto_proveedor_descripcion.trim() }}</span>
                        </td>
                        <!-- <td>
                          <mdb-checkbox [checked]="doc.es_activo_fijo" onclick="return false"></mdb-checkbox>
                        </td> -->
                        <td>{{ doc.cantidad_recibida }}</td>
                        <td>{{ doc.formato_codigo }}</td>
                        <td>$ {{ doc.precio_unitario | numerico }}</td>
                        <td>
                          <span *ngIf="doc.desc_es_porcentaje === true">{{ doc.descuento }} %</span>
                          <span *ngIf="doc.desc_es_porcentaje === false">$ {{ doc.descuento | numerico }}</span>
                        </td>
                        <td>
                          <span *ngIf="doc.rec_es_porcentaje === true">{{ doc.recargo }} %</span>
                          <span *ngIf="doc.rec_es_porcentaje === false">$ {{ doc.recargo | numerico }}</span>
                        </td>
                        <td>{{ doc.sku }}</td>
                        <td>{{ doc.producto_descripcion.trim() }}</td>
                        <td>{{ doc.tipo_item_nombre }}</td>
                        <td>{{ doc.total_linea | numerico }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col align-items-center">
                <button (click)="DeleteDetalle()" type="button" mdbBtn color="warning" size="sm" mdbWavesEffect>
                  <span *ngIf="countSelectDetalle === 0">Eliminar</span>
                  <span *ngIf="countSelectDetalle > 0"> Eliminar {{ countSelectDetalle }} seleccionados</span>
                </button>
              </div>
              <div class="col" style="max-width: 200px">
                <div class="md-form">
                  <input value="{{ totalMonto | numerico }}" type="text" id="campo1" class="form-control"
                    placeholder="0" required #campo1 />
                  <label for="campo1">Total Detalle</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="CloseDocRecManualmente()" mdbWavesEffect>Cerrar</button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          [disabled]="loading == false" (click)="saveDocRecManualmente()">Guardar</button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()"></app-modal-seleccionar-proveedor>

<!-- MODAL SELECCIONAR PRODUCTO -->
<app-modal-seleccionar-producto-proveedor [enviaRutProveedor]="seleccionaRutProveedor"
  (onSelect)="onProductSeleccionado($event)" showInfoProveedorInactivoBloqueado="true"
  (onNotFound)="onProductoNoEncontrado()"></app-modal-seleccionar-producto-proveedor>